export default __webpack_public_path__ + "static/media/2.2fb6d7c2.png";